const ctx = self as unknown as Worker;

ctx.addEventListener('message', e => {
  // console.log('received', e.data);
  ctx.postMessage('Hello, World!!');
});
